interface AvatarProps {
  name: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  colorIndex?: number;
}

const colors = [
  'bg-[#003B4A] text-white',
  'bg-[#0E7A8A] text-white',
  'bg-[#FF5533] text-white',
  'bg-[#84F2B4] text-[#0F1720]',
  'bg-[#F59E0B] text-white',
];

const sizes = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-16 h-16 text-lg',
  xl: 'w-20 h-20 text-xl',
};

export function Avatar({ name, size = 'md', colorIndex = 0 }: AvatarProps) {
  const initials = name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const colorClass = colors[colorIndex % colors.length];
  const sizeClass = sizes[size];

  return (
    <div
      className={`${sizeClass} ${colorClass} rounded-full flex items-center justify-center font-semibold transition-all duration-200 ease-out`}
      style={{ transform: 'rotate(-3deg)' }}
    >
      {initials}
    </div>
  );
}
